import { render, staticRenderFns } from "./dex-cards.vue?vue&type=template&id=00bf0f9b&scoped=true"
import script from "./dex-cards.vue?vue&type=script&lang=ts"
export * from "./dex-cards.vue?vue&type=script&lang=ts"
import style0 from "./dex-cards.vue?vue&type=style&index=0&id=00bf0f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf0f9b",
  null
  
)

export default component.exports